import styled from "styled-components";
import Footer from "./component";

export default styled(Footer)`
    color: #DDD !important;
    background-color: #2C293B;
    padding-top: 10px;
    text-align: center;
    border-bottom: solid 5px #00BFA5;
    z-index: 2;
    position: relative;
`;